<template>
  <div class="mt-n5">
    <v-card
      v-if="process.loading"
      class="pa-2"
    >
      <v-skeleton-loader
        ref="skeleton"
        :boilerplate="false"
        :type="'list-item-avatar, article, list-item-three-line@6'"
        class="mx-auto"
        width="100vw"
        max-width="600"
      />
    </v-card>

    <v-card
      v-if="demographics && !process.loading"
      class="mx-auto"
      width="100vw"
      max-width="600"
      :loading="process.saving"
    >
      <v-card-title class="justify-space-between">
        <span class="primary--text">
          Additional Info
        </span>

        <v-btn
          v-if="!editFlag"
          color="primary lighten-2"
          @click="editFlag = true"
        >
          Edit
          <v-icon
            small
          >
            create
          </v-icon>
        </v-btn>
        <v-btn
          v-else
          :loading="process.saving"
          @click="saveDemographics"
        >
          Save
        </v-btn>
      </v-card-title>

      <v-card-text class="py-1">
        <div>
          The demographic data below will be used to match leaders
          in selecting a coach on the GCG Platform.
        </div>

        <div>
          <v-btn
            class="text-decoration-underline"
            color="primary"
            text
            @click="$router.push({ name: 'formOne' })"
          >
            Sign up here to start coaching on the GCG Platform.
          </v-btn>
        </div>

        <v-form
          ref="form"
          v-model="validate"
          class="pt-3"
        >
          <!-- Question 1 -->
          <v-select
            v-model="demographics.highest_degree"
            class="pb-4"
            :items="degreesList"
            item-value="key"
            item-text="value"
            :loading="process.list.length > 0"
            placeholder="Please select an option"
            :rules="rules.highest_degree"
            :disabled="!editFlag"
            required
          >
            <template #label>
              1. What is the highest academic degree that you have earned?
              <span class="error--text">*</span>
            </template>
          </v-select>

          <!-- Question 2 -->
          <Question2
            v-if="demographics.degree_list"
            :edit-flag="editFlag"
            :rules="rules"
            :list-loadind="process.list.length > 0"
            :degrees-list="degreesList"
            :degrees.sync="demographics.degree_list"
          />

          <!-- Question 3 -->
          <v-select
            v-model="demographics.coaching_exp"
            class="pb-4"
            :items="experienceList"
            item-value="key"
            item-text="value"
            :loading="process.list.length > 0"
            placeholder="Please select an option"
            :rules="rules.coaching_exp"
            :disabled="!editFlag"
            required
          >
            <template #label>
              3. How many years of experience do you have as an executive/leadership coach?
              <span class="error--text">*</span>
            </template>
          </v-select>

          <!-- Question 4 -->
          <v-select
            v-model="demographics.coaching_certifications"
            class="pb-4"
            :items="certificationList"
            item-value="key"
            item-text="value"
            :loading="process.list.length > 0"
            placeholder="Please select an option"
            :rules="rules.coaching_certifications"
            :disabled="!editFlag"
            required
            multiple
            chips
            small-chips
            deletable-chips
          >
            <template #label>
              4. What other coaching certifications do you have, if any?
              <span class="error--text">*</span>
            </template>
          </v-select>

          <!-- Question 5 -->
          <Question5
            v-if="demographics.coaching_certifications_others"
            :add-flag="demographics.coaching_certifications.includes('other')"
            :edit-flag="editFlag"
            :rules="rules"
            :certifications-other.sync="demographics.coaching_certifications_others"
          />

          <!-- Question 6 -->
          <v-select
            v-model="demographics.corp_years_exp"
            class="pb-4"
            :items="corporateExperienceList"
            item-value="key"
            item-text="value"
            :loading="process.list.length > 0"
            placeholder="Please select an option"
            :rules="rules.corp_years_exp"
            :disabled="!editFlag"
            required
          >
            <template #label>
              6. How many years of corporate work experience do you have?
              <span class="error--text">*</span>
            </template>
          </v-select>

          <!-- Question 7 -->
          <v-select
            v-model="demographics.industries"
            class="pb-4"
            :items="industriesList"
            item-value="key"
            item-text="value"
            :loading="process.list.length > 0"
            placeholder="Please select an option"
            :rules="rules.industries"
            :disabled="!editFlag"
            required
            multiple
            chips
            small-chips
            deletable-chips
          >
            <template #label>
              7. What industries did you work in?
              <span class="error--text">*</span>
            </template>
          </v-select>

          <!-- Question 8 -->
          <v-select
            v-model="demographics.func_responsibilities"
            class="pb-4"
            :items="functionalAreasList"
            item-value="key"
            item-text="value"
            :loading="process.list.length > 0"
            placeholder="Please select an option"
            :rules="rules.func_responsibilities"
            :disabled="!editFlag"
            required
            multiple
            chips
            small-chips
            deletable-chips
          >
            <template #label>
              8. What was your functional responsibility?
              <span class="error--text">*</span>
            </template>
          </v-select>

          <!-- Question 9 -->
          <v-select
            v-model="demographics.highest_lvl_seniority"
            class="pb-4"
            :items="organizationalLevelList"
            item-value="key"
            item-text="value"
            :loading="process.list.length > 0"
            placeholder="Please select an option"
            :rules="rules.highest_lvl_seniority"
            :disabled="!editFlag"
            required
          >
            <template #label>
              9. What was your highest level of seniority?
              <span class="error--text">*</span>
            </template>
          </v-select>

          <!-- Question 10 -->
          <Question10
            v-if="demographics.largest_employers"
            :edit-flag="editFlag"
            :largest-employers.sync="demographics.largest_employers"
          />
        </v-form>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn
          v-if="!editFlag"
          color="primary lighten-2"
          @click="editFlag = true"
        >
          Edit
          <v-icon
            small
          >
            create
          </v-icon>
        </v-btn>
        <v-btn
          v-else
          :loading="process.saving"
          @click="saveDemographics"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import coachApi from '@/api/coach-profile/coach';
import demographicsApi from '@/api/commons/demographics';
import Question2 from './widget/Question2.vue';
import Question5 from './widget/Question5.vue';
import Question10 from './widget/Question10.vue';

export default {
  name: 'Demographics',

  components: {
    Question2,
    Question5,
    Question10,
  },

  data() {
    const that = this;
    return {
      process: {
        list: [],
        loading: false,
        saving: false,
      },
      postFlag: false,
      editFlag: false,
      validate: true,
      initStructure: {
        highest_degree: null,
        degree_list: [
          {
            degree: null,
            major: null,
            other: null,
          },
        ],
        coaching_exp: null,
        coaching_certifications: [],
        coaching_certifications_others: [],
        corp_years_exp: null,
        industries: [],
        func_responsibilities: [],
        highest_lvl_seniority: null,
        largest_employers: [],
      },
      demographics: null,
      rules: {
        highest_degree: [
          (v) => !!v || 'Please input value',
        ],
        degree_list: [
          (v) => !!v || 'Please input value',
        ],
        coaching_exp: [
          (v) => !!v || 'Please input value',
        ],
        coaching_certifications: [
          (v) => !!v || 'Please input value',
          (v) => v.length > 0 || 'Please input value',
        ],
        coaching_certifications_others: [
          () => {
            if (that.demographics
                && that.demographics.coaching_certifications.includes('other')) {
              if (!that.demographics.coaching_certifications_others
                || !that.demographics.coaching_certifications_others.length) {
                return 'Please input value';
              }
            }
            return true;
          },
        ],
        corp_years_exp: [
          (v) => !!v || 'Please input value',
        ],
        industries: [
          (v) => !!v || 'Please input value',
          (v) => v.length > 0 || 'Please input value',
        ],
        func_responsibilities: [
          (v) => !!v || 'Please input value',
          (v) => v.length > 0 || 'Please input value',
        ],
        highest_lvl_seniority: [
          (v) => !!v || 'Please input value',
        ],
        // largest_employers: [
        //   (v) => !!v || 'Please input value',
        // ],
      },
      degreesList: [],
      experienceList: [],
      certificationList: [],
      corporateExperienceList: [],
      industriesList: [],
      functionalAreasList: [],
      organizationalLevelList: [],
    };
  },

  created() {
    this.getDemographics();

    // Get lists
    this.getDegreeList();
    this.getExperienceList();
    this.getCertificationList();
    this.getCorporateExperienceList();
    this.getIndustriesList();
    this.getFunctionalAreasList();
    this.getOrganizationalLevelList();
  },

  methods: {
    async getDemographics() {
      try {
        this.process.loading = true;
        const response = await coachApi.getCoachDemographics();

        // If there is original data, fill out missing fields before use
        const obj = {};
        Object.keys(this.initStructure).forEach((key) => {
          if (key === 'degree_list' && response[key] && !response[key].length) {
            response[key].push({
              degree: null,
              major: null,
              other: null,
            });
          }
          if (response[key]) {
            obj[key] = response[key];
          } else {
            obj[key] = this.initStructure[key];
          }
        });
        this.demographics = obj;
      } catch (err) {
        console.log(err);
        this.demographics = this.initStructure;
        if (err.msg) {
          if (err.msg.includes('is not set') || err.msg.includes('Not found')) {
            this.postFlag = true;
          } else {
            this.$toast.error(err.msg);
          }
        }
      } finally {
        this.process.loading = false;
      }
    },

    async getDegreeList() {
      try {
        this.process.list.push('run');
        this.degreesList = await demographicsApi.getDegreeTypes();
      } catch (err) {
        console.log(err);
        this.$toast.error(err.msg);
      } finally {
        this.process.list.pop();
      }
    },

    async getExperienceList() {
      try {
        this.process.list.push('run');
        this.experienceList = await demographicsApi.getCoachExpTypes();
      } catch (err) {
        console.log(err);
        this.$toast.error(err.msg);
      } finally {
        this.process.list.pop();
      }
    },

    async getCertificationList() {
      try {
        this.process.list.push('run');
        this.certificationList = await demographicsApi.getCoachingCertTypes();
      } catch (err) {
        console.log(err);
        this.$toast.error(err.msg);
      } finally {
        this.process.list.pop();
      }
    },

    async getCorporateExperienceList() {
      try {
        this.process.list.push('run');
        this.corporateExperienceList = await demographicsApi.getCorpWorkExpTypes();
      } catch (err) {
        console.log(err);
        this.$toast.error(err.msg);
      } finally {
        this.process.list.pop();
      }
    },

    async getIndustriesList() {
      try {
        this.process.list.push('run');
        this.industriesList = await demographicsApi.getIndustryTypes();
      } catch (err) {
        console.log(err);
        this.$toast.error(err.msg);
      } finally {
        this.process.list.pop();
      }
    },

    async getFunctionalAreasList() {
      try {
        this.process.list.push('run');
        this.functionalAreasList = await demographicsApi.getFunctionalAreaTypes();
      } catch (err) {
        console.log(err);
        this.$toast.error(err.msg);
      } finally {
        this.process.list.pop();
      }
    },

    async getOrganizationalLevelList() {
      try {
        this.process.list.push('run');
        this.organizationalLevelList = await demographicsApi.getOrgLvlTypes();
      } catch (err) {
        console.log(err);
        this.$toast.error(err.msg);
      } finally {
        this.process.list.pop();
      }
    },

    async saveDemographics() {
      if (this.$refs.form.validate()) {
        try {
          this.process.saving = true;
          if (this.postFlag) {
            await coachApi.createCoachDemographics(this.demographics);
          } else {
            await coachApi.updateCoachDemographics(this.demographics);
          }
          this.editFlag = false;
          this.$toast.success('Changes successfully saved.');
        } catch (err) {
          console.log(err);
          this.$toast.error(err.msg);
        } finally {
          this.process.saving = false;
        }
      }
    },
  },
};
</script>
